import {useContext} from "react";
import {
    CitationPreviewContext,
    type CitationPreviewContextValue,
} from "./CitationPreviewContext";

/** Reads the shared citation preview state. Safe outside the provider. */
export function useCitationPreview(): CitationPreviewContextValue {
    return useContext(CitationPreviewContext);
}
